"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldLoadSSO = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const mobx_1 = require("mobx");
const sso_client_1 = __importDefault(require("telia-sso-client/lib/sso-client"));
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
const crm_components_1 = require("crm-components");
class SsoStore {
    constructor(rootStore) {
        Object.defineProperty(this, "loaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "mandateChangeRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hardAuthRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "canRepresent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "customerHasLegalMandate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "initStores", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "allowStatisticsCookies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "auth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sso", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasLegalMandateNoStipulation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoIframeOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "handleSegmentCookieChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.customer) {
                    const segmentFromCookie = js_cookie_1.default.get('segment');
                    const segment = this.customer.type ? this.customer.type.toLowerCase() : 'general';
                    if (!segmentFromCookie || segmentFromCookie !== segment) {
                        js_cookie_1.default.set('segment', segment, { domain: '.telia.ee', expires: 365 });
                    }
                }
            }
        });
        Object.defineProperty(this, "ensureLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (redirectUrl = null) => {
                if (!this.isLoggedIn) {
                    this.startLogin(redirectUrl);
                }
                else if (redirectUrl) {
                    (0, crm_components_1.navigate)(redirectUrl);
                }
            }
        });
        Object.defineProperty(this, "ensureHardLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (redirectUrl = null) => {
                this.hardAuthRequired = true;
                if (!this.loginLevelSufficient) {
                    this.startLogin(redirectUrl);
                }
                else if (redirectUrl) {
                    (0, crm_components_1.navigate)(redirectUrl);
                }
            }
        });
        Object.defineProperty(this, "handleLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (ssoResult) => {
                this.auth = ssoResult.auth;
                if (this.isLoggedIn) {
                    this.closeSsoIframe();
                    await this.checkUserRepresentation();
                }
                this.loaded = true;
            }
        });
        Object.defineProperty(this, "handleLogout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.auth = null;
                this.initStores = false;
                (0, crm_components_1.navigate)('/');
                this.closeSsoIframe();
            }
        });
        Object.defineProperty(this, "doLogout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.sso.doLogout();
            }
        });
        Object.defineProperty(this, "startLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (redirectUrl = null) => {
                this.loginRequired = true;
            }
        });
        Object.defineProperty(this, "resetLoginRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.hardAuthRequired = false;
                this.mandateChangeRequired = false;
                this.loginRequired = false;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.locationStore = rootStore.locationStore;
        const path = window.location.pathname;
        if ((0, exports.shouldLoadSSO)(path)) {
            this.sso = sso_client_1.default.connect({
                onLogin: this.handleLogin,
                onLogout: this.handleLogout
            }, {
                locale: this.locationStore.currentLanguage,
                allowStatisticsCookies: this.allowStatisticsCookies.toString(),
                autoSelectSelf: true
            });
            this.sso.loadInitialState();
            (0, mobx_1.autorun)(() => this.handleSegmentCookieChange());
            (0, mobx_1.autorun)(() => {
                this.sso.setOptions({
                    locale: this.locationStore.currentLanguage,
                    authLevel: this.mandateChangeRequired ? null : 2,
                    allowStatisticsCookies: this.allowStatisticsCookies.toString()
                });
            });
            window.addEventListener('CookiebotOnLoad', () => {
                (0, mobx_1.runInAction)(() => (this.allowStatisticsCookies = window.Cookiebot ? window.Cookiebot.consent.statistics : false));
                if (this.ssoFrameVisible) {
                    window.dispatchEvent(new Event('refreshSsoIframe'));
                }
            });
        }
    }
    openSsoIframe() {
        this.ssoIframeOpen = true;
    }
    closeSsoIframe() {
        this.ssoIframeOpen = false;
    }
    get isSsoIframeOpen() {
        return this.ssoIframeOpen;
    }
    get isLoggedIn() {
        return !!this.auth;
    }
    get isLoggedInWithHardAuth() {
        return this.isLoggedIn && this.auth.authLevel > 1;
    }
    get isHardAuthWithCustomer() {
        return this.isLoggedInWithHardAuth && !!this.auth.customer;
    }
    get isDealerWithSelectedCustomer() {
        return this.isDealer && !!this.auth.customer;
    }
    get isDealerWithoutSelectedCustomer() {
        return this.isDealer && !this.isDealerWithSelectedCustomer;
    }
    get loginLevelSufficient() {
        return this.hardAuthRequired ? this.isLoggedInWithHardAuth || !!this.isDealer : this.isLoggedIn;
    }
    get isPrivateCustomer() {
        return this.auth && this.auth.customer && this.auth.customer.type === 'B2C';
    }
    get isBusinessCustomer() {
        return this.auth && this.auth.customer && this.auth.customer.type === 'B2B';
    }
    get isSsoScriptInitialized() {
        return !!this.sso;
    }
    isSamePerson(personalCode) {
        return this.auth.person.personalCode === personalCode;
    }
    get isDealerOrHasNoStipulation() {
        return !(this.isBusinessCustomer && !this.hasLegalMandateNoStipulation && !this.isDealer);
    }
    get ssoFrameVisible() {
        return this.isSsoScriptInitialized && this.loginRequired && (!this.loginLevelSufficient || this.mandateChangeRequired);
    }
    get isDealer() {
        return this.auth && !!this.auth.dealer;
    }
    get customer() {
        return !!this.auth && this.auth.customer;
    }
    get customerId() {
        return !!this.customer && this.customer.customerId;
    }
    logoutAndReloadIfNeeded(response) {
        if (response && response.status === 403) {
            this.doLogout();
            window.location.reload();
        }
    }
    checkUserRepresentation() {
        if (this.auth.customer && this.auth.person) {
            return ApiUtil_1.default.get('/representation')
                .then((0, mobx_1.action)((response) => {
                this.canRepresent = response.data.canRepresent;
                this.customerHasLegalMandate = response.data.customerHasLegalMandate;
                this.hasLegalMandateNoStipulation = response.data.hasLegalMandateNoStipulation;
                if (this.isLoggedIn && response.data.canRepresent) {
                    this.initStores = true;
                }
            }))
                .catch((e) => {
                this.logoutAndReloadIfNeeded(e.response);
            });
        }
    }
}
exports.default = SsoStore;
__decorate([
    mobx_1.observable
], SsoStore.prototype, "loaded", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "loginRequired", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "mandateChangeRequired", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "hardAuthRequired", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "canRepresent", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "customerHasLegalMandate", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "initStores", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "allowStatisticsCookies", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "auth", void 0);
__decorate([
    mobx_1.observable
], SsoStore.prototype, "ssoIframeOpen", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "openSsoIframe", null);
__decorate([
    mobx_1.action
], SsoStore.prototype, "closeSsoIframe", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isSsoIframeOpen", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isLoggedIn", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isLoggedInWithHardAuth", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isHardAuthWithCustomer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isDealerWithSelectedCustomer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isDealerWithoutSelectedCustomer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "loginLevelSufficient", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isPrivateCustomer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isBusinessCustomer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isSsoScriptInitialized", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isDealerOrHasNoStipulation", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "ssoFrameVisible", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "isDealer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "customer", null);
__decorate([
    mobx_1.computed
], SsoStore.prototype, "customerId", null);
__decorate([
    mobx_1.action
], SsoStore.prototype, "logoutAndReloadIfNeeded", null);
__decorate([
    mobx_1.action
], SsoStore.prototype, "ensureLogin", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "ensureHardLogin", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "handleLogin", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "checkUserRepresentation", null);
__decorate([
    mobx_1.action
], SsoStore.prototype, "handleLogout", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "doLogout", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "startLogin", void 0);
__decorate([
    mobx_1.action
], SsoStore.prototype, "resetLoginRequired", void 0);
const shouldLoadSSO = (path) => {
    if (!path) {
        return true;
    }
    const noSSOPaths = ['/valideerimine'];
    return !noSSOPaths.find((noSSOPath) => path.includes(noSSOPath));
};
exports.shouldLoadSSO = shouldLoadSSO;
